import React from "react";

import "../assets/css/style.css"
import "../assets/css/reset.css"
import "../assets/css/responsive-leyouts.css"

export function SelectOperater({operaters, selectedOperator, onChange}) {

    function defOption(selectedOperator) {
        return selectedOperator ?
            <option value="" disabled>Izaberite uslugu</option>
            : <option value="" disabled selected>Izaberite uslugu</option>
    }

    function option(item, selectedOperator) {
        return selectedOperator && item.name == selectedOperator.name ?
            <option selected>{item.name}</option>
            : <option>{item.name}</option>
    }

    return <section>
        <label className="select">
            <select name="gender" id="operator"
                    onChange={(event) => onChange && onChange(event.target.value)}
                    required="required">
                {defOption(selectedOperator)}
                {operaters.map(item => option(item, selectedOperator))}
            </select>
            <i></i>
        </label>
    </section>

}
